/* eslint-disable */
import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import DownloadIcon from 'static/images/icons/download.svg'
import KardiaRxEcgTable from 'views/containers/KardiaRxEcgTable'
import KardiaRxCCTEcgTable from 'views/containers/KardiaRxCCTEcgTable'
import { EditEnrollDisableCheck } from './util'
import history from '../../containers/History'
import ContentHeader from '../../containers/ContentHeader'
import Loading from '../../components/Loading'
import GetAge from '../../components/GetAge'
import EcgLoader from '../../containers/EcgLoader'
import { CustomReportDatePopover } from '../../containers/Popovers'
import PatientPendingMessage from '../../components/PatientPendingMessage'
import {
  EkgTable,
  BloodPressureTable,
  ReportTable,
  EnrollmentTable,
  WeightTable,
} from '../../containers/Tables'
import PageTab from '../../components/PageTab'
import PageTabs from '../../components/PageTabs'
import { getWeightSourceOptions, getWeightSeverityOptions, getPhysicianName } from '../../containers/Utilities'
import {
  ROUTES,
  HEADER_HEIGHT,
  KARDIA_PRO_START_DATE,
  KARDIA_PRO_END_DATE,
  getBloodPressureSeverityOptions,
  ALL_PHYSICIANS_OPTION,
  ALL_PRESCRIPTIONS_OPTION,
  TABLE_ACTIONS_HEIGHT,
  TABLE_TOOLBAR_ONE_LEVEL,
  TABLE_TOOLBAR_TWO_LEVEL,
  getEsignOptions,
  getExportOptions,
  PATIENT_FILE_TABS,
  MIN_BPM_VALUE,
  MAX_BPM_VALUE,
  MIN_SYSTOLIC_VALUE,
  MAX_SYSTOLIC_VALUE,
  MIN_DIASTOLIC_VALUE,
  MAX_DIASTOLIC_VALUE,
  ALL_RECORDINGS_TRIGGER_OPTION,
  TRIAGE_OPTION,
  SCROLLBAR_WIDTH,
  CUSTOM_TRIGGER_DEFAULT,
  PRIMARY_TRIGGER_TYPES,
  TRIGGER_FREQUENCY_TYPES,
  getPrimaryTriggerOption,
  CUSTOM_TRIGGER_OPTION,
  TRIGGER_TYPES,
  BOTTOM_PADDING,
  ENROLLMENT_CONNECTION_STATUSES,
  AUTHORIZATION_TYPES,
  getSexDisplayText,
  getPrimaryInsuranceDisplayText,
  getSecondaryInsuranceDisplayText,
  TABLE_HEADER_HEIGHT,
  ENROLLMENT_TABLE_ROW_HEIGHT,
  EKG_TABLE_ROW_HEIGHT,
  MAX_BMI_VALUE,
  MIN_BMI_VALUE,
  MAX_WEIGHT_VALUE,
  MIN_WEIGHT_VALUE,
  parseDobFormDisplay,
  US_STATES,
} from '../../constants'
import { getEkgResultOptions } from '../../constants/recordingMaps'
import styles from './PatientFile.css'
import { needToBustCache, filterIsPhysicianPermission } from '../../store/appReducer'
import { TemporaryEcgHackedGraph, TemporaryWeightHackedGraph, TemporaryBloodPressureHackedGraph, TemporaryKardiaRxEcgHackedGraph } from '../../containers/Graphs'

import { EditPatientForm, EditIDTFPatientForm, PrescribeForm, EnrollmentForm, PatientDetailForm } from '../../containers/Forms'
import KardiaRxReport from '../../containers/Forms/KardiaRxReport'
import { checkRpmFeatureEnabled, checkIdtfFeatureEnabled, checkIdtfServiceProviderFeatureEnabled, checkNSRNotificationStatus } from 'configs'
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent'
import PendingIcon from 'static/images/pending.svg'
import AliveCorLogo from 'static/images/AliveCorLabs-NewLogo.png'
import QrCode from 'static/images/qr-code.png'
import AlertBar from '../../../views/components/Common/AlertBar'
import { ALERT_SEVERITY, OVERRIDE_STYLE, ALERT_MSG } from '../../../views/components/Common/AlertBar/Constants'
import { STUDY_DURATION_DAY_EVENT_MCT } from '../../../views/constsnts/patientEnrollmentConstants'

class PatientFile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      innerHeight: 0,
      innerWidth: 0,

      isAnyDataSelected: false,
      showButtons: true,
    }
    this.beginningDate = KARDIA_PRO_START_DATE
    this.today = KARDIA_PRO_END_DATE
  }

  UNSAFE_componentWillMount() {
    const {
      match,
      location,
      dataLastUpdated,
      setInitialPatientFileData,
      getPatientFileData,
    } = this.props

    setInitialPatientFileData(match, location)
    getPatientFileData(needToBustCache(dataLastUpdated))

    window.addEventListener('resize', this.handleResize)
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    this.setState({
      innerHeight: window.innerHeight,
      innerWidth: window.innerWidth,
    })
  }

  handleOnTabClick = tab => {
    const {
      selectedTab,
      handleOnTabClick: onTabClick,
    } = this.props
    const {
      isAnyDataSelected,
    } = this.state

    const isAnyDataSelectedInNewTab = tab !== selectedTab ? false : isAnyDataSelected
    this.setState({
      isAnyDataSelected: isAnyDataSelectedInNewTab,
    })

    onTabClick(tab)
  }

  render() {
    const {
      browser,
      dataIsFetching,
      dataLastUpdated,
      getPatientFileData,
      match,
      authorizationType,
      patient: patientDataSource,
      patients,
      ekgs,
      bloodPressures,
      weights,
      enrollments: enrollmentsDataSource,
      reports: reportsDataSource,
      physicians,
      prescriptions,
      teamTriggers,
      patientTriggers: patientTriggersDataSource,
      billingCodes,
      icd10Codes,
      selectedIndex,
      selectedTab,
      // selectedPatientId,
      handleOnFilterButtonClick,
      handleOnRefreshClick,
      handleOnSelectionClick,
      refreshClicked,
      bulkActionComplete,
      bulkActionIsFetching,
      bulkActionSuccessMessage,
      selectedPopover,

      enrollmentIds,
      handleOnEnrollmentSortClick,
      handleOnEnrollmentFilterChange,
      enrollmentSortBy,
      enrollmentSortDirection,
      selectedEnrollmentStartStartDate,
      selectedEnrollmentStartEndDate,
      selectedEnrollmentEndStartDate,
      selectedEnrollmentEndEndDate,
      selectedEnrollmentPrescriptionId,
      selectedEnrollmentIcd10CodeId,
      selectedEnrollmentBillingCode,
      selectedEnrollmentOrderNumber,

      bloodPressureRecordingIds,
      setSelectedBloodPressureRecording,
      clearSelectedBloodPressureRecording,
      handleOnBloodPressureFilterChange,
      handleOnBloodPressureTableScroll,
      handleOnBloodPressureSortClick,
      updateSelectedBloodPressures,
      bloodPressureSortBy,
      bloodPressureSortDirection,
      selectedBloodPressureRecordingId,
      selectedBloodPressureSource,
      selectedBloodPressureSeverity,
      selectedBloodPressureStartDate,
      selectedBloodPressureEndDate,
      selectedBloodPressureBpmStartValue,
      selectedBloodPressureBpmEndValue,
      selectedBloodPressureSystolicStartValue,
      selectedBloodPressureSystolicEndValue,
      selectedBloodPressureDiastolicStartValue,
      selectedBloodPressureDiastolicEndValue,
      selectedBloodPressures,

      ekgRecordingIds,
      setSelectedEkgRecording,
      clearSelectedEkgRecording,
      handleOnEkgSortClick,
      handleOnEkgFilterChange,
      handleOnEkgTableScroll,
      handleOnEkgRowClick,
      handleOnEkgBulkAction,
      updateSelectedEkgs,
      ekgSortBy,
      ekgSortDirection,
      selectedEkgRecordingId,
      selectedEkgPhysicianId,
      selectedEkgPhysicians,
      selectedEkgResult,
      selectedEkgStartDate,
      selectedEkgEndDate,
      selectedEkgBpmStartValue,
      selectedEkgBpmEndValue,
      selectedEkgs,

      reportIds,
      reportSortBy,
      reportSortDirection,
      handleOnReportSortClick,
      handleOnReportFilterChange,
      handleOnReportsBulkAction,
      handleOnReportRowClick,
      updateSelectedReports,
      selectedReportEsignedId,
      selectedReportExportedId,
      selectedReportPhysicianId,
      selectedReportPhysicians,
      selectedReportPrescriptionId,
      selectedReportBillingCode,
      selectedReportStartDate,
      selectedReportEndDate,
      selectedReports,

      weightRecordingIds,
      setSelectedWeightRecording,
      clearSelectedWeightRecording,
      handleOnWeightFilterChange,
      handleOnWeightTableScroll,
      handleOnWeightSortClick,
      updateSelectedWeights,
      weightSortBy,
      weightSortDirection,
      selectedWeightRecordingId,
      selectedWeightStartDate,
      selectedWeightEndDate,
      selectedWeightSource,
      selectedWeightSeverity,
      selectedWeightBmiStartValue,
      selectedWeightBmiEndValue,
      selectedWeightWeightStartValue,
      selectedWeightWeightEndValue,
      selectedWeights,

      prescribeFormData,
      enrollmentFormData,
      prescribeFormPristine,
      enrollmentFormPristine,
      editPatientFormPristine,
      handleEditPatientFormSubmit,
      handlePrescribeForm,
      handleEnrollmentEditForm,
      handleIdtfEnrollmentEditForm,
      handleEnrollmentOnRevokeClick,

      customReportDateRange,
      customReportPopoverOpen,
      toggleCustomReportPopover,
      updateCustomReportRequest,
      setNSRStatus,
      fetchCustomReport,
      updateCustomReportPopoverState,
      customReportPdf,
      templateList,
      me,
      kardiaRxIDTFEcg,
      kardiaRxCCTEcg,
      insurances,
      addresses,
      pateintEnrollOverview,
      idtfEnrollments,
    } = this.props
    const {
      params,
    } = match
    const {
      innerHeight,
      innerWidth,
    } = this.state

    // use patient id from url to determine current patient instead of state
    // fix needed for having EKG tab default
    const selectedPatientId = this.props.match.params.patientId
    const height = innerHeight - HEADER_HEIGHT - BOTTOM_PADDING
    const width = 1180 - (20 * 2)

    let patient
    let cleanProfile

    // get IDTF feature is enabled status
    const isIdtfEnabled = checkIdtfFeatureEnabled(me)
    const isIdtfServiceEnabled = checkIdtfServiceProviderFeatureEnabled(me)
    const NSRNotificationStatus = checkNSRNotificationStatus(me)
    let isKM6L = false
    let isKardiaPatch = false
    let rpmUser = false
    if(isIdtfEnabled) {
      if(pateintEnrollOverview && pateintEnrollOverview.data && pateintEnrollOverview.data['latest_enrollment']) {
        isKM6L = pateintEnrollOverview.data.latest_enrollment.device == 'KM6L'
        isKardiaPatch = pateintEnrollOverview.data.latest_enrollment.device == 'kardiaPatch'
      }
      else {
        rpmUser = true
      }
    }

    // To rewmove add patient and download report button in case of Kardia Rx ECG tab
    if(selectedTab === PATIENT_FILE_TABS.KARDIA_RX) {
      this.state.showButtons = false
    } else {
      this.state.showButtons = true
    }


    // clean patient profile for edit page
    // TODO: move this out of render so this function is not recreated every time render is called
    const cleanPatientProfile = (profile) => {
      const newDob = parseDobFormDisplay(profile.dob, me)
      const socialSecurityNumber= profile.socialSecurityNumber
      const newPhone = profile.phone ? profile.phone.replace(/^(\+1)/g, '') : ''
      const primaryInsuranceType = insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.insuranceType !== 'not_known' ? {
        label: getPrimaryInsuranceDisplayText(insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.insuranceType),
        value: insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.insuranceType,
      } : ''
      const secondaryInsuranceType = insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.insuranceType !== 'not_known' ? {
        label: getSecondaryInsuranceDisplayText(insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.insuranceType),
        value: insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.insuranceType,
      } : ''

      const primaryState= addresses.data && addresses.data.primary_address && addresses.data.primary_address.state
      const patientState= US_STATES.filter((item) => item.code == primaryState)
      const secondaryState= addresses.data && addresses.data.shipping_address && addresses.data.shipping_address.state
      const shippingState= US_STATES.filter((item) => item.code == secondaryState)
      const alternatePhone = profile.alternatePhone ? profile.alternatePhone.replace(/^(\+1)/g, '') : ''
      const emergencyContactName = profile.emergencyContactName
      const emergencyContactPhone = profile.emergencyContactPhone ? profile.emergencyContactPhone.replace(/^(\+1)/g, '') : ''
      const patientAddressLine1= addresses.data && addresses.data.primary_address && addresses.data.primary_address.primaryLine
      const patientAddressLine2= addresses.data && addresses.data.primary_address && addresses.data.primary_address.secondaryLine
      const patientCity= addresses.data && addresses.data.primary_address && addresses.data.primary_address.city
      const patientZip= addresses.data && addresses.data.primary_address && addresses.data.primary_address.postalCode
      const shippingAddressLine1= addresses.data && addresses.data.shipping_address && addresses.data.shipping_address.primaryLine
      const shippingAddressLine2= addresses.data && addresses.data.shipping_address && addresses.data.shipping_address.secondaryLine
      const shippingCity= addresses.data && addresses.data.shipping_address && addresses.data.shipping_address.city
      const shippingZip= addresses.data && addresses.data.shipping_address && addresses.data.shipping_address.postalCode
      // const primaryInsuranceType= insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.insuranceType
      const primaryMedicareId= insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.medicareId
      const primaryInsuranceCompanyName= insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.insuranceCompanyName
      const primaryInsuranceGroup= insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.insuranceGroup
      const primaryInsuranceAuthorizationNumber= insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.insuranceAuthorizationNumber
      const primaryPolicyHolderName= insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.policyHolderName
      const primaryPolicyHolderRelationship= insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.policyHolderRelationship
      const primarySubscriberId = insurances.data && insurances.data.primary_insurance && insurances.data.primary_insurance.subscriberId
      // const secondaryInsuranceType= insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.insuranceType
      const secondaryMedicareId= insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.medicareId
      const secondaryInsuranceCompanyName= insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.insuranceCompanyName
      const secondaryInsuranceGroup= insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.insuranceGroup
      const secondaryInsuranceAuthorizationNumber= insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.insuranceAuthorizationNumber
      const secondaryPolicyHolderName= insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.policyHolderName
      const secondaryPolicyHolderRelationship= insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.policyHolderRelationship
      const secondarySubscriberId = insurances.data && insurances.data.secondary_insurance && insurances.data.secondary_insurance.subscriberId
      const newSex = profile.sex && profile.sex !== 'not_known' ? {
        label: getSexDisplayText(profile.sex),
        value: profile.sex,
      } : ''

      const participantCustomFields = profile.participantCustomFields || []
      const customFields = participantCustomFields.reduce((prev, {fieldName, fieldValue}) =>{
        return {...prev, [fieldName]: fieldValue }
       },{})
  
      const newProfile = {
        ...profile,
        dob: newDob,
        phone: newPhone,
        sex: newSex,
        socialSecurityNumber: socialSecurityNumber,
        alternatePhone: alternatePhone,
        emergencyContactName: emergencyContactName,
        emergencyContactPhone: emergencyContactPhone,
        patientAddressLine1: patientAddressLine1,
        patientAddressLine2: patientAddressLine2,
        patientCity: patientCity,
        patientState: patientState,
        patientZip: patientZip,
        shippingAddressLine1: shippingAddressLine1,
        shippingAddressLine2: shippingAddressLine2,
        shippingCity: shippingCity,
        shippingState: shippingState,
        shippingZip: shippingZip,
        primaryInsuranceType: primaryInsuranceType,
        primaryMedicareId: primaryMedicareId,
        primaryInsuranceCompanyName: primaryInsuranceCompanyName,
        primaryInsuranceGroup: primaryInsuranceGroup,
        primaryInsuranceAuthorizationNumber: primaryInsuranceAuthorizationNumber,
        primaryPolicyHolderName: primaryPolicyHolderName,
        primaryPolicyHolderRelationship: primaryPolicyHolderRelationship,
        primarySubscriberId: primarySubscriberId,
        secondaryInsuranceType: secondaryInsuranceType,
        secondaryMedicareId: secondaryMedicareId,
        secondaryInsuranceCompanyName: secondaryInsuranceCompanyName,
        secondaryInsuranceGroup: secondaryInsuranceGroup,
        secondaryInsuranceAuthorizationNumber: secondaryInsuranceAuthorizationNumber,
        secondaryPolicyHolderName: secondaryPolicyHolderName,
        secondaryPolicyHolderRelationship: secondaryPolicyHolderRelationship,
        secondarySubscriberId: secondarySubscriberId,
        ...customFields
      }
      return newProfile
    }

    if (patients.data && patients.data.byId[selectedPatientId]) {
      patient = patients.data.byId[selectedPatientId]
      cleanProfile = cleanPatientProfile(patient)
    }

    let selectedTemplate = []
    selectedTemplate = patient && templateList && templateList.data && templateList.data.source.filter(item => {if(item.id === patient.connectionTemplateID) { return item}})
    const isKiwiAuth = selectedTemplate && selectedTemplate[0] && selectedTemplate[0].type && selectedTemplate[0].type.String === 'kiwi-auth' && selectedTemplate[0].type.Valid === true

    /* Profile tab */
    let currentEnrollment = {}
    let enrollmentCode
    let enrollments = []
    if (patient && patient.enrollments && enrollmentsDataSource.data) {
      const currentEnrollmentId = patient.enrollments
        .find(id => enrollmentsDataSource.data.byId[id]
          && enrollmentsDataSource.data.byId[id].connectionStatus === patient.connectionStatus)
      if (currentEnrollmentId) {
        currentEnrollment = enrollmentsDataSource.data.byId[currentEnrollmentId]
        enrollmentCode = currentEnrollment.code
      }

      enrollments = enrollmentIds
        .map(id => enrollmentsDataSource.data.byId[id])
        .filter(enrollment => {
          if (!enrollment) return false

          // remove if pending code
          // remove if expired pending code
          if ((enrollment.connectionStatus === ENROLLMENT_CONNECTION_STATUSES.PENDING)
            || (enrollment.connectionStatus === ENROLLMENT_CONNECTION_STATUSES.EXPIRED
                && enrollment.startDate === null)
          ) {
            return false
          }
          return true
        })
    }

    // Initial Values for Prescribe
    let prescribeInitialValues = {
      custom: {
        ...CUSTOM_TRIGGER_DEFAULT,
      },
      ekgReviewWhichRecordings: ALL_RECORDINGS_TRIGGER_OPTION,
      ekgReviewWhereRecordings: TRIAGE_OPTION,
      email: patient && patient.email,
    }

    const getFormInboxPresets = (triggersById, typeToIdLookup, presets) => {
      const newPresets = {
        ...presets,
      }
      const whichPrimaryTriggerType = Object.keys(PRIMARY_TRIGGER_TYPES).find(triggerType => {
        const id = typeToIdLookup[triggerType]
        return triggersById[id].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS
      })

      if (whichPrimaryTriggerType) {
        const id = typeToIdLookup[whichPrimaryTriggerType]
        const triggerData = triggersById[id]
        newPresets.ekgReviewWhichRecordings = getPrimaryTriggerOption(whichPrimaryTriggerType, triggerData)
      } else {
        newPresets.ekgReviewWhichRecordings = CUSTOM_TRIGGER_OPTION
        const possibleAFibResultId = typeToIdLookup[TRIGGER_TYPES.POSSIBLE_AFIB_DETECTION]
        if (triggersById[possibleAFibResultId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.possibleAFibResultCheckmark = true
        }
        const possibleAFibResultWithHrId = typeToIdLookup[TRIGGER_TYPES.HEART_RATE_OVER_X_AND_AFIB]
        if (triggersById[possibleAFibResultWithHrId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.possibleAFibResultWithHrCheckmark = true
          newPresets.custom.possibleAFibResultWithHr = parseInt(triggersById[possibleAFibResultWithHrId].value, 10)
        }
        const allUnclassifiedId = typeToIdLookup[TRIGGER_TYPES.ALL_UNCLASSIFIED]
        if (triggersById[allUnclassifiedId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.unclassifiedResultCheckmark = true
        }
        const heartRateUnderId = typeToIdLookup[TRIGGER_TYPES.HEART_RATE_UNDER_X]
        if (triggersById[heartRateUnderId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.heartRateUnderCheckmark = true
          newPresets.custom.heartRateUnder = parseInt(triggersById[heartRateUnderId].value, 10)
        }
        const heartRateOverId = typeToIdLookup[TRIGGER_TYPES.HEART_RATE_OVER_X]
        if (triggersById[heartRateOverId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
          newPresets.custom.heartRateOverCheckmark = true
          newPresets.custom.heartRateOver = parseInt(triggersById[heartRateOverId].value, 10)
        }
        if (typeToIdLookup[TRIGGER_TYPES.BRADYCARDIA]) {
          const bradycardiaId = typeToIdLookup[TRIGGER_TYPES.BRADYCARDIA]
          if (triggersById[bradycardiaId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
            newPresets.custom.bradycardia = true
          }
        }
        if (typeToIdLookup[TRIGGER_TYPES.TACHYCARDIA]) {
          const tachycardiaId = typeToIdLookup[TRIGGER_TYPES.TACHYCARDIA]
          if (triggersById[tachycardiaId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
            newPresets.custom.tachycardia = true
          }
        }
        if (typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_PVC]) {
          const sinusRhythmWithPVCsId = typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_PVC]
          if (triggersById[sinusRhythmWithPVCsId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
            newPresets.custom.sinusRhythmWithPVCs = true
          }
        }
        if (typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_SVE]) {
          const sinusRhythmWithSVEsId = typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_SVE]
          if (triggersById[sinusRhythmWithSVEsId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
            newPresets.custom.sinusRhythmWithSVEs = true
          }
        }
        if (typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_WIDE_QRS]) {
          const sinusRhythmWithWideQRSId = typeToIdLookup[TRIGGER_TYPES.SINUS_RHYTHM_WIDE_QRS]
          if (triggersById[sinusRhythmWithWideQRSId].frequency === TRIGGER_FREQUENCY_TYPES.ALWAYS) {
            newPresets.custom.sinusRhythmWithWideQRS = true
          }
        }
      }
      return newPresets
    }

    // Team trigger default for which recordings
    if (teamTriggers.data) {
      prescribeInitialValues = {
        ...prescribeInitialValues,
        ...getFormInboxPresets(teamTriggers.data.byId, teamTriggers.data.typeToIdLookup, prescribeInitialValues),
      }
    }

    let enrollmentFormInitialValues = Object.assign({}, currentEnrollment, {
      custom: {
        ...CUSTOM_TRIGGER_DEFAULT,
      },
      billingCodes: null,
      icd10Codes: null,
      idtfDuration: {},
      device_serial_number: null,
    })

    let showQrInfo = false
    // chek if IDTF enable, set chek true
    if (isIdtfEnabled) {
      const templateInfo = patient && patient.connectionTemplateID && templateList && templateList.data && templateList.data.source && templateList.data.source.filter(item => item.id === patient.connectionTemplateID)
      if (templateInfo && templateInfo.length > 0 && templateInfo[0].isIDTF === true) {
        showQrInfo = true
      }
      // templet -- && isIdtf -- > match
      // showQrInfo = true / false
    } else {
      showQrInfo = false
    }

    if (currentEnrollment && typeof currentEnrollment.billingCodes !== 'string' && currentEnrollment.billingCodes !== undefined) {
      enrollmentFormInitialValues.billingCodes = currentEnrollment.billingCodes
    }

    if (currentEnrollment && typeof currentEnrollment.icd10Codes !== 'string' && currentEnrollment.icd10Codes !== undefined) {
      enrollmentFormInitialValues.icd10Codes = currentEnrollment.icd10Codes
    }

    if(idtfEnrollments && idtfEnrollments.data && idtfEnrollments.data[0] && idtfEnrollments.data[0].duration) {
      enrollmentFormInitialValues.idtfDuration = STUDY_DURATION_DAY_EVENT_MCT.filter((item) => item.value == idtfEnrollments.data[0].duration);
    }

    if(pateintEnrollOverview && pateintEnrollOverview.data && pateintEnrollOverview.data['latest_enrollment']) {
      enrollmentFormInitialValues.device_serial_number = pateintEnrollOverview.data.latest_enrollment.device_serial_number
    }

    // There is a team's version of triggers and a patient's version of triggers (when the user has a connection status of pending or connected)
    const patientTriggers = {
      isFetching: true,
    }
    if (patientTriggersDataSource.data && physicians.data && patient && patient.triggers) {
      enrollmentFormInitialValues = {
        ...enrollmentFormInitialValues,
        ...getFormInboxPresets(patient.triggers.byId, patient.triggers.typeToIdLookup, enrollmentFormInitialValues),
      }
      if (!patient.assignedMemberID) {
        enrollmentFormInitialValues.ekgReviewWhereRecordings = TRIAGE_OPTION
      } else {
        enrollmentFormInitialValues.ekgReviewWhereRecordings = {
          ...physicians.data.byId[patient.assignedMemberID],
        }
      }
      patientTriggers.data = patient.triggers
      patientTriggers.isFetching = false
    }

    // console.log(currentEnrollment, enrollmentFormInitialValues, enrollmentFormData)

    /* Reports table */
    let reports = []
    if (patient && patient.reports && reportsDataSource.data && !refreshClicked) {
      reports = reportIds.map(id => reportsDataSource.data.byId[id])
    }
    // console.log(reports)
    /* Reports table */

    let chartHeight = 185
    if (browser.name === 'ie') {
      chartHeight += 17
    } else {
      chartHeight += 11
    }

    /* EKGs table */
    let completeEkgRecordings = []
    let ekgRecordings = []
    let selectedEkgRecording
    if (patient && patient.recordings && ekgs.data && !refreshClicked) {
      selectedEkgRecording = selectedEkgRecordingId ? ekgs.data.byId[selectedEkgRecordingId] : null
      completeEkgRecordings = patient.recordings.map(id => ekgs.data.byId[id])
      ekgRecordings = ekgRecordingIds.map(id => ekgs.data.byId[id])
    }

    let physicianEkgOptions = []
    const noneEkgOptionItem = {
      id: '0',
      label: '<None>',
    }

    if (physicians && physicians.data) {
      physicianEkgOptions = [ noneEkgOptionItem ]
        .concat(filterIsPhysicianPermission(physicians.data.sortedByLastName.map(id => physicians.data.byId[id]))
          .map(p => ({
            id: p.id,
            label: getPhysicianName(p.firstName, p.lastName, ''),
          })))
    }
    /* EKGs table */

    /* Blood Pressure table */
    let completeBloodPressureRecordings = []
    let bloodPressureRecordings = []
    let selectedBloodPressureRecording
    if (patient && patient.bloodPressure && bloodPressures.data && !refreshClicked) {
      selectedBloodPressureRecording = selectedBloodPressureRecordingId ? bloodPressures.data.byId[selectedBloodPressureRecordingId] : null
      completeBloodPressureRecordings = patient.bloodPressure.map(id => bloodPressures.data.byId[id])
      bloodPressureRecordings = bloodPressureRecordingIds.map(id => bloodPressures.data.byId[id])
    }
    /* Blood Pressure table */

    /* Weight table */
    let completeWeightRecordings = []
    let weightRecordings = []
    let selectedWeightRecording
    if (patient && patient.weight && weights.data && !refreshClicked) {
      selectedWeightRecording = selectedWeightRecordingId ? weights.data.byId[selectedWeightRecordingId] : null
      completeWeightRecordings = patient.weight.map(id => weights.data.byId[id])
      weightRecordings = weightRecordingIds.map(id => weights.data.byId[id])
    }
    /* Weight table */

    /* GA metric value */
    let gaValue
    if (patient) {
      switch (patient.connectionStatus) {
      case 'none':
        gaValue = 0
        break
      case 'connected':
        gaValue = 1
        break
      case 'pending':
        gaValue = 2
        break
      default:
        gaValue = -1
        break
      }

      // if (selectedTab === PATIENT_FILE_TABS.EKGS
      //   && !((dataIsFetching && !patient && (patient && !patient.weight)) || refreshClicked)) {
      //   ReactGA.event({
      //     category: 'patient-ecg-table',
      //     action: 'default-tab-ecg',
      //     value: gaValue
      //   })
      // }
    }

    const getTabContent = tab => {
      let content = null

      switch (tab) {
      case PATIENT_FILE_TABS.OVERVIEW:
        content = !((dataIsFetching && !patient) || refreshClicked) ? (
          <div
            className={styles.formWrapper}
            style={{
              height,
            }}
            id="formPrint"
          >
            {patient && patient.connectionStatus !== 'none' ? (
              <div>
                {(isIdtfEnabled || isIdtfServiceEnabled) && showQrInfo && (
                  <React.Fragment>
                    <img className={styles.alivecorLogo} src={AliveCorLogo} id='qrCodeImage'/>
                    {isKM6L || rpmUser ? (
                      <React.Fragment>
                        <p className={styles.formHeading}>
                          Scan to download the app:
                        </p>
                        <div
                          style={{ display: 'flex' }}
                          className={styles.pendingMessage}
                        >
                          <img className={styles.qrCode} src={QrCode} />
                          <div className={styles.copy}>
                            <div className={styles.message}>
                              <div>
                                Please refer to the{' '}
                                <span className={styles.textWeight}>
                                  AliveCor Labs Quick Start Guide
                                </span>{' '}
                                for assistance with <br />
                                connecting{' '}
                                <span className={styles.textWeight}>
                                  KardiaMobile 6L
                                </span>{' '}
                                to the patient KardiaRx app.
                              </div>
                              <div className={styles.textDiv}>
                                if you need further assistance, please call the Alivecor Labs Customer Service <br />
                                at (833)525-1400.
                                We are available 24 hours a day, 7 days a week
                                to
                                <br />
                                answer your questions.
                              </div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                      isKardiaPatch && (
                        <React.Fragment>
                          <div className={styles.message}>
                            <div
                              style={{ marginLeft: '55px', marginTop: '30px' }}
                            >
                              If you need further assistance, please call the Alivecor Labs Customer Service at (833)525-1400. We
                              are available 24 hours a day, 7 days a week to
                              answer your questions.
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )}
                  </React.Fragment>
                )}
                {/* Show this section only when IDTF service provider is enabled */}
                {isIdtfServiceEnabled && (
                  <React.Fragment>
                    <img className={styles.alivecorLogo} src={AliveCorLogo} />
                    <p className={styles.formHeading}>
                      Scan to download the app:
                    </p>
                    <div
                      style={{ display: 'flex' }}
                      className={styles.pendingMessage}
                    >
                      <img className={styles.qrCode} src={QrCode} />
                      <div className={styles.copy}>
                        <div className={styles.message}>
                          <div>
                            Please refer to the{' '}
                            <span className={styles.textWeight}>
                              AliveCor Labs Quick Start Guide
                            </span>{' '}
                            for assistance with <br />
                            connecting{' '}
                            <span className={styles.textWeight}>
                              KardiaMobile 6L
                            </span>{' '}
                            to the patient KardiaRx app.
                          </div>
                          <div className={styles.textDiv}>
                            if you need further assistance, please call the Alivecor Labs Customer Service <br />
                            at (833)525-1400.
                            We are available 24 hours a day, 7 days a week to
                            <br />
                            answer your questions.
                          </div>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}
                <div className={styles.formTop}>
                  {!isKardiaPatch && (
                    <h2
                      style={{ borderTop: '1px solid #EFEFEF' }}
                      className={styles.formTitle}
                    >
                      Connection Status
                    </h2>
                  )}
                  {!isKardiaPatch && (
                    <div className={!isIdtfEnabled ? styles.formSection : ''}>
                      {patient && patient.connectionStatus === 'connected' && (
                        <div className={styles.connectionStatus}>
                          <span className={styles.connected} />
                          Connected
                        </div>
                      )}
                      {patient && patient.connectionStatus === 'pending' && (
                        <PatientPendingMessage
                          currentEnrollment={currentEnrollment}
                          codes={patient.codes}
                          me={me}
                        />
                      )}
                      {(isIdtfServiceEnabled || isIdtfEnabled || isKiwiAuth) &&
                        patient &&
                        patient.connectionStatus !== 'pending' && (
                          <PatientPendingMessage
                            currentEnrollment={currentEnrollment}
                            codes={patient.codes}
                            me={me}
                          />
                        )}
                    </div>
                  )}
                  {(isIdtfEnabled || isIdtfServiceEnabled) && (
                    <React.Fragment>
                      <h2 className={styles.formTitle}>Patient Information</h2>
                      <PatientDetailForm initialValues={cleanProfile} me={me}/>
                    </React.Fragment>
                  )}
                  <h2 className={styles.formTitle}>Order Information</h2>
                  <EnrollmentForm
                    key={patient && patient.id}
                    physicians={physicians}
                    triggers={patientTriggers}
                    billingCodes={billingCodes}
                    icd10Codes={icd10Codes}
                    enrollmentFormData={enrollmentFormData}
                    onSubmit={isIdtfEnabled ? handleIdtfEnrollmentEditForm : handleEnrollmentEditForm}
                    initialValues={enrollmentFormInitialValues}
                    connectionStatus={patient.connectionStatus}
                    showRevoke={true}
                    handleOnRevokeClick={() =>
                      handleEnrollmentOnRevokeClick(
                        patient.connectionStatus,
                        enrollmentCode,
                      )
                    }
                    isSubmitting={
                      !enrollmentFormPristine &&
                      (patientDataSource.isFetching ||
                        patientTriggers.isFetching ||
                        patients.isFetching)
                    }
                    me={me}
                    isIdtfEnabled={isIdtfEnabled || isIdtfServiceEnabled}
                    isIdtfServiceEnabled={isIdtfServiceEnabled}
                    pateintEnrollOverview={pateintEnrollOverview}
                  />
                </div>
              </div>
            ) : (
              <PrescribeForm
                key={patient && patient.id}
                physicians={physicians}
                prescriptions={prescriptions}
                triggers={teamTriggers}
                billingCodes={billingCodes}
                icd10Codes={icd10Codes}
                prescribeFormData={prescribeFormData}
                onSubmit={handlePrescribeForm}
                initialValues={prescribeInitialValues}
                isSubmitting={
                  !prescribeFormPristine &&
                  (patientDataSource.isFetching ||
                    patientTriggers.isFetching ||
                    patients.isFetching)
                }
              />
            )}
          </div>
        ) : (
          <div
            className={styles.contentWrapper}
            style={{
              height,
            }}
          >
            <EcgLoader />
          </div>
        );
        break
      case PATIENT_FILE_TABS.PROFILE:
        content = !isIdtfServiceEnabled && !((dataIsFetching && !patient) || refreshClicked)
          ? (
            <div
              className={styles.formWrapper}
              style={{
                height,
              }}
            >
              <div className={styles.formTop}>
                <h2 className={styles.formTitle}>Patient Information</h2>
                { cleanProfile && (
                    isIdtfEnabled ? 
                    (
                    <EditIDTFPatientForm 
                      initialValues={cleanProfile}
                      physicians={physicians}
                      onSubmit={handleEditPatientFormSubmit}
                     isSubmitting={!editPatientFormPristine && (patientDataSource.isFetching || patientTriggers.isFetching || patients.isFetching)}
                     me={me}
                 />):(
                      <EditPatientForm
                      initialValues={cleanProfile}
                      physicians={physicians}
                      onSubmit={handleEditPatientFormSubmit}
                      isSubmitting={!editPatientFormPristine && (patientDataSource.isFetching || patientTriggers.isFetching || patients.isFetching)}
                      me={me}
                    />    
                    ) 
                )
                }
              </div>
              <div className={styles.formTop}>
                <h2 className={styles.formTitle}>Connection History</h2>
                <div
                  className={styles.tableContent}
                  style={{
                    height: isIdtfEnabled ? '300px' : (enrollments.length * ENROLLMENT_TABLE_ROW_HEIGHT) + TABLE_HEADER_HEIGHT,
                  }}
                >
                  <EnrollmentTable
                    data={enrollments}
                    idtfEnrollments={idtfEnrollments}
                    showRowSelection={false}
                    // onSelectionClick={updateSelectedEnrollments}
                    // height={height}
                    rowHeight={ENROLLMENT_TABLE_ROW_HEIGHT}
                    width={width}
                    sortBy={enrollmentSortBy}
                    sortDirection={enrollmentSortDirection}
                    me={me}
                    filterStartDate={!moment(selectedEnrollmentStartStartDate).isSame(this.beginningDate, 'day') || !moment(selectedEnrollmentStartEndDate).isSame(this.today, 'day')}
                    filterEndDate={!moment(selectedEnrollmentEndStartDate).isSame(this.beginningDate, 'day') || !moment(selectedEnrollmentEndEndDate).isSame(this.today, 'day')}
                    filterPrescription={selectedEnrollmentPrescriptionId}
                    filterIcd10Code={selectedEnrollmentIcd10CodeId}
                    filterBillingCode={selectedEnrollmentBillingCode.length > 0}
                    filterOrderNumber={selectedEnrollmentOrderNumber}
                    handleOnFilterButtonClick={handleOnFilterButtonClick}
                    handleOnFilterChange={handleOnEnrollmentFilterChange}
                    handleOnSortClick={handleOnEnrollmentSortClick}
                    handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
                    handleOnPopoverKeyUp={e => {
                      const enterKeyCode = 13
                      if (typeof handleOnFilterButtonClick === 'function' && e.keyCode === enterKeyCode) {
                        handleOnFilterButtonClick(null)
                      }
                    }}
                    selectedPopover={selectedPopover}
                    selectedStartStartDate={selectedEnrollmentStartStartDate}
                    selectedStartEndDate={selectedEnrollmentStartEndDate}
                    startDateRange={[ this.beginningDate, this.today ]}
                    selectedEndStartDate={selectedEnrollmentEndStartDate}
                    selectedEndEndDate={selectedEnrollmentEndEndDate}
                    endDateRange={[ this.beginningDate, this.today ]}
                    selectedPrescriptionId={selectedEnrollmentPrescriptionId}
                    prescriptions={prescriptions}
                    selectedIcd10CodeId={selectedEnrollmentIcd10CodeId}
                    icd10Codes={icd10Codes}
                    selectedBillingCode={selectedEnrollmentBillingCode}
                    billingCodes={billingCodes}
                    selectedOrderNumber={selectedEnrollmentOrderNumber}
                  />
                </div>
              </div>
            </div>
          )
          : (
            <div
              className={styles.contentWrapper}
              style={{
                height,
              }}
            >
              <EcgLoader />
            </div>
          )
        break
      case PATIENT_FILE_TABS.REPORTS:
        content = !isIdtfServiceEnabled && (
          <div
            className={styles.tableContent}
            style={{
              height,
              width,
            }}
          >
            <ReportTable
              enableLoader={reportIds.length === 0 || refreshClicked}
              showLoader={dataIsFetching}
              data={reports}
              showRowSelection={true}
              selected={selectedReports}
              onSelectionClick={selected => handleOnSelectionClick(selected, updateSelectedReports)}
              height={height}
              width={width}
              onRowClick={handleOnReportRowClick}
              selectedIndex={selectedIndex}
              sortBy={reportSortBy}
              sortDirection={reportSortDirection}
              me={me}
              filterEndDate={!moment(selectedReportStartDate).isSame(this.beginningDate, 'day') || !moment(selectedReportEndDate).isSame(this.today, 'day')}
              filterPhysician={selectedReportPhysicians && selectedReportPhysicians.length > 0}
              filterPrescription={selectedReportPrescriptionId}
              filterBillingCode={selectedReportBillingCode.length > 0}
              filterEsign={selectedReportEsignedId !== getEsignOptions()[0].id}
              filterExport={selectedReportExportedId !== getExportOptions()[0].id}
              handleOnFilterButtonClick={handleOnFilterButtonClick}
              handleOnFilterChange={handleOnReportFilterChange}
              handleOnSortClick={handleOnReportSortClick}
              handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
              handleOnBulkAction={handleOnReportsBulkAction}
              handleOnBulkActionClearSelection={() => handleOnSelectionClick({}, updateSelectedReports)}
              bulkActionComplete={bulkActionComplete}
              bulkActionIsFetching={bulkActionIsFetching}
              bulkActionSuccessMessage={bulkActionSuccessMessage}
              selectedPopover={selectedPopover}
              selectedStartDate={selectedReportStartDate}
              selectedEndDate={selectedReportEndDate}
              dateRange={[ this.beginningDate, this.today ]}
              showPatientColumns={false}
              physicians={physicians}
              selectedPhysicianId={selectedReportPhysicianId}
              selectedPhysicians={selectedReportPhysicians}
              prescriptions={prescriptions}
              selectedPrescriptionId={selectedReportPrescriptionId}
              billingCodes={billingCodes}
              selectedBillingCode={selectedReportBillingCode}
              esignOptions={getEsignOptions().slice(1)}
              selectedEsignedId={selectedReportEsignedId}
              exportOptions={getExportOptions().slice(1)}
              selectedExportedId={selectedReportExportedId}
            />
          </div>
        )
        break
      case PATIENT_FILE_TABS.EKGS:
        content = !isIdtfServiceEnabled && !((dataIsFetching && !patient && (patient && !patient.recordings)) || refreshClicked)
          ? (
            <React.Fragment>
              {!NSRNotificationStatus && !isIdtfEnabled && !isIdtfServiceEnabled &&
              <AlertBar
                severity={ALERT_SEVERITY.INFO}
                overrideStyle={OVERRIDE_STYLE.NSR}
                textMsg={ALERT_MSG.NSR_INFO}
                onClickClose={()=>setNSRStatus(true)}
              />}
              <div
                className={styles.ecgPage}
                style={{
                  height,
                }}
              >
                <div className={styles.ecgGraph}>
                  <TemporaryEcgHackedGraph
                    completeRecordings={completeEkgRecordings}
                    recordingIds={ekgRecordingIds}
                    recordings={ekgRecordings}
                    selectedRecording={selectedEkgRecording}
                    setSelectedRecording={rec => setSelectedEkgRecording(ekgRecordingIds, rec)}
                    clearSelectedRecording={clearSelectedEkgRecording}
                    width={width}
                  />
                </div>
                <div
                  className={styles.tableContent}
                  style={{
                    // height: (ekgRecordings.length * EKG_TABLE_ROW_HEIGHT) + TABLE_HEADER_HEIGHT,
                    // width,
                    height: height - chartHeight - 24 - 16,
                  }}
                  data-page="patient-ecg-table"
                  data-value={ekgRecordings.length}
                >
                  <EkgTable
                    enableLoader={ekgRecordingIds.length === 0 || refreshClicked}
                    showLoader={dataIsFetching}
                    data={ekgRecordings}
                    rowHeight={EKG_TABLE_ROW_HEIGHT}
                    showRowSelection={true}
                    selected={selectedEkgs}
                    onSelectionClick={selected => handleOnSelectionClick(selected, updateSelectedEkgs)}
                    // height={height}
                    width={width}
                    onScroll={handleOnEkgTableScroll}
                    onRowClick={handleOnEkgRowClick}
                    selectedIndex={selectedIndex}
                    sortBy={ekgSortBy}
                    sortDirection={ekgSortDirection}
                    me={me}
                    filterDate={!moment(selectedEkgStartDate).isSame(this.beginningDate, 'day') || !moment(selectedEkgEndDate).isSame(this.today, 'day')}
                    filterAnalysis={selectedEkgResult.length > 0}
                    filterAnalysisBy={selectedEkgPhysicianId}
                    filterPhysician={
                      selectedEkgPhysicians && selectedEkgPhysicians.length > 0
                    }
                    filterBpm={selectedEkgBpmStartValue !== MIN_BPM_VALUE || selectedEkgBpmEndValue !== MAX_BPM_VALUE}
                    handleOnFilterButtonClick={handleOnFilterButtonClick}
                    handleOnFilterChange={handleOnEkgFilterChange}
                    handleOnSortClick={handleOnEkgSortClick}
                    handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
                    handleOnBulkAction={handleOnEkgBulkAction}
                    handleOnBulkActionClearSelection={() => handleOnSelectionClick({}, updateSelectedEkgs)}
                    bulkActionComplete={bulkActionComplete}
                    bulkActionIsFetching={bulkActionIsFetching}
                    bulkActionSuccessMessage={bulkActionSuccessMessage}
                    showBulkActionRemove={false}
                    selectedPopover={selectedPopover}
                    selectedStartDate={selectedEkgStartDate}
                    selectedEndDate={selectedEkgEndDate}
                    dateRange={[this.beginningDate, this.today]}
                    selectedBpmStartValue={selectedEkgBpmStartValue}
                    selectedBpmEndValue={selectedEkgBpmEndValue}
                    bpmRange={[MIN_BPM_VALUE, MAX_BPM_VALUE]}
                    showPatientColumns={false}
                    showOrderingProvider={false}
                    physicians={physicians}
                    physicianOptions={physicianEkgOptions}
                    selectedPhysicianId={selectedEkgPhysicianId}
                    selectedPhysicians={selectedEkgPhysicians}
                    ekgResults={getEkgResultOptions().slice(1)}
                    selectedEkgResult={selectedEkgResult}
                  />
                </div>
              </div>
            </React.Fragment>
          )
          : (
            <div
              className={styles.contentWrapper}
              style={{
                height,
              }}
            >
              <EcgLoader />
            </div>
          )
        break
      case PATIENT_FILE_TABS.KARDIA_RX:
        content = (isIdtfEnabled || isIdtfServiceEnabled) && !((dataIsFetching && !patient && (patient && !patient.recordings)) || refreshClicked)
          ? (
            <div
              className={styles.ecgPage}
              style={{
                height,
                paddingTop: '20px',
              }}
            >
              <React.Fragment>
                {!isIdtfServiceEnabled && <KardiaRxReport
                location= {this.props.location}
                />}
                <div className={styles.ecgGraph}>
                  {isIdtfEnabled &&
                    <TemporaryKardiaRxEcgHackedGraph
                      completeRecordings={kardiaRxIDTFEcg.recordings.data[0]}
                      recordingIds={ekgRecordingIds}
                      recordings={kardiaRxIDTFEcg.recordings.data[0]}
                      selectedRecording={selectedEkgRecording}
                      setSelectedRecording={rec => setSelectedEkgRecording(ekgRecordingIds, rec)}
                      clearSelectedRecording={clearSelectedEkgRecording}
                      width={width}
                    />
                  }
                  {isIdtfServiceEnabled &&
                    <TemporaryKardiaRxEcgHackedGraph
                      completeRecordings={kardiaRxCCTEcg.recordings.data[0]}
                      recordingIds={ekgRecordingIds}
                      recordings={kardiaRxCCTEcg.recordings.data[0]}
                      selectedRecording={selectedEkgRecording}
                      setSelectedRecording={rec => setSelectedEkgRecording(ekgRecordingIds, rec)}
                      clearSelectedRecording={clearSelectedEkgRecording}
                      width={width}
                    />
                  }
                </div>
              </React.Fragment>
              <div
                className={styles.tableContent}
                style={{
                  // height: (ekgRecordings.length * EKG_TABLE_ROW_HEIGHT) + TABLE_HEADER_HEIGHT,
                  // width,
                  height: height - chartHeight - 24 - 16,
                }}
                data-page="patient-ecg-table"
                data-value={ekgRecordings.length}
              >
                {isIdtfEnabled &&
                  <KardiaRxEcgTable {...this.props}/>
                }
                {isIdtfServiceEnabled &&
                  <KardiaRxCCTEcgTable {...this.props}/>
                }
              </div>
            </div>
          )
          : (
            <div
              className={styles.contentWrapper}
              style={{
                height,
              }}
            >
              <EcgLoader />
            </div>
          )
        break
      case PATIENT_FILE_TABS.BLOOD_PRESSURES:
        content = !isIdtfServiceEnabled && !((dataIsFetching && !patient && (patient && !patient.bloodPressure)) || refreshClicked)
          ? (
            <div
              className={styles.ecgPage}
              style={{
                height,
              }}
            >
              <div className={styles.ecgGraph}>
                <TemporaryBloodPressureHackedGraph
                  completeRecordings={completeBloodPressureRecordings}
                  recordingIds={bloodPressureRecordingIds}
                  recordings={bloodPressureRecordings}
                  selectedRecording={selectedBloodPressureRecording}
                  setSelectedRecording={rec => setSelectedBloodPressureRecording(bloodPressureRecordingIds, rec)}
                  clearSelectedRecording={clearSelectedBloodPressureRecording}
                  width={width}
                />
              </div>
              <div
                className={styles.tableContent}
                style={{
                  // height: (ekgRecordings.length * EKG_TABLE_ROW_HEIGHT) + TABLE_HEADER_HEIGHT,
                  // width,
                  height: height - chartHeight - 24 - 16,
                }}
                data-page="patient-bpm-table"
                data-value={bloodPressureRecordings.length}
              >
                <BloodPressureTable
                  enableLoader={bloodPressureRecordingIds.length === 0 || refreshClicked}
                  showLoader={dataIsFetching}
                  data={bloodPressureRecordings}
                  showRowSelection={false}
                  selected={selectedBloodPressures}
                  onSelectionClick={selected => handleOnSelectionClick(selected, updateSelectedBloodPressures)}
                  // height={height}
                  width={width}
                  onScroll={handleOnBloodPressureTableScroll}
                  selectedIndex={selectedIndex}
                  sortBy={bloodPressureSortBy}
                  sortDirection={bloodPressureSortDirection}
                  me={me}
                  filterDate={!moment(selectedBloodPressureStartDate).isSame(this.beginningDate, 'day') || !moment(selectedBloodPressureEndDate).isSame(this.today, 'day')}
                  filterSource={selectedBloodPressureSource.length > 0}
                  filterCategory={selectedBloodPressureSeverity.length > 0}
                  filterBpm={selectedBloodPressureBpmStartValue !== MIN_BPM_VALUE || selectedBloodPressureBpmEndValue !== MAX_BPM_VALUE}
                  filterSystolic={selectedBloodPressureSystolicStartValue !== MIN_SYSTOLIC_VALUE || selectedBloodPressureSystolicEndValue !== MAX_SYSTOLIC_VALUE}
                  filterDiastolic={selectedBloodPressureDiastolicStartValue !== MIN_DIASTOLIC_VALUE || selectedBloodPressureDiastolicEndValue !== MAX_DIASTOLIC_VALUE}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  handleOnFilterChange={handleOnBloodPressureFilterChange}
                  handleOnSortClick={handleOnBloodPressureSortClick}
                  handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
                  selectedPopover={selectedPopover}
                  selectedStartDate={selectedBloodPressureStartDate}
                  selectedEndDate={selectedBloodPressureEndDate}
                  dateRange={[ this.beginningDate, this.today ]}
                  showPatientColumns={false}
                  selectedSource={selectedBloodPressureSource}
                  selectedSeverity={selectedBloodPressureSeverity}
                  selectedBpmStartValue={selectedBloodPressureBpmStartValue}
                  selectedBpmEndValue={selectedBloodPressureBpmEndValue}
                  bpmRange={[ MIN_BPM_VALUE, MAX_BPM_VALUE ]}
                  selectedSystolicStartValue={selectedBloodPressureSystolicStartValue}
                  selectedSystolicEndValue={selectedBloodPressureSystolicEndValue}
                  systolicRange={[ MIN_SYSTOLIC_VALUE, MAX_SYSTOLIC_VALUE ]}
                  selectedDiastolicStartValue={selectedBloodPressureDiastolicStartValue}
                  selectedDiastolicEndValue={selectedBloodPressureDiastolicEndValue}
                  diastolicRange={[ MIN_DIASTOLIC_VALUE, MAX_DIASTOLIC_VALUE ]}
                />
              </div>
            </div>
          )
          : (
            <div
              className={styles.contentWrapper}
              style={{
                height,
              }}
            >
              <EcgLoader />
            </div>
          )
        break
      case PATIENT_FILE_TABS.WEIGHTS:
        content = !isIdtfServiceEnabled && !((dataIsFetching && !patient && (patient && !patient.weight)) || refreshClicked)
          ? (
            <div
              className={styles.ecgPage}
              style={{
                height,
              }}
            >
              <div className={styles.ecgGraph}>
                <TemporaryWeightHackedGraph
                  completeRecordings={completeWeightRecordings}
                  recordingIds={weightRecordingIds}
                  recordings={weightRecordings}
                  selectedRecording={selectedWeightRecording}
                  setSelectedRecording={rec => setSelectedWeightRecording(weightRecordingIds, rec)}
                  clearSelectedRecording={clearSelectedWeightRecording}
                  width={width}
                  me={me}
                />
              </div>
              <div
                className={styles.tableContent}
                style={{
                  // height: (ekgRecordings.length * EKG_TABLE_ROW_HEIGHT) + TABLE_HEADER_HEIGHT,
                  // width,
                  height: height - chartHeight - 24 - 16,
                }}
                data-page="patient-weight-table"
                data-value={weightRecordings.length}
              >
                <WeightTable
                  enableLoader={weightRecordingIds.length === 0 || refreshClicked}
                  showLoader={dataIsFetching}
                  data={weightRecordings}
                  showRowSelection={false}
                  selected={selectedWeights}
                  onSelectionClick={selected => handleOnSelectionClick(selected, updateSelectedWeights)}
                  // height={height}
                  width={width}
                  onScroll={handleOnWeightTableScroll}
                  selectedIndex={selectedIndex}
                  sortBy={weightSortBy}
                  sortDirection={weightSortDirection}
                  me={me}
                  filterDate={!moment(selectedWeightStartDate).isSame(this.beginningDate, 'day') || !moment(selectedWeightEndDate).isSame(this.today, 'day')}
                  filterSource={selectedWeightSource.length > 0}
                  filterCategory={selectedWeightSeverity.length > 0}
                  filterBmi={selectedWeightBmiStartValue !== MIN_BMI_VALUE || selectedWeightBmiEndValue !== MAX_BMI_VALUE}
                  filterWeight={selectedWeightWeightStartValue !== MIN_WEIGHT_VALUE || selectedWeightWeightEndValue !== MAX_WEIGHT_VALUE}
                  handleOnFilterButtonClick={handleOnFilterButtonClick}
                  handleOnFilterChange={handleOnWeightFilterChange}
                  handleOnSortClick={handleOnWeightSortClick}
                  handleOnOutsidePopoverClick={() => handleOnFilterButtonClick(null)}
                  selectedPopover={selectedPopover}
                  selectedStartDate={selectedWeightStartDate}
                  selectedEndDate={selectedWeightEndDate}
                  dateRange={[ this.beginningDate, this.today ]}
                  showPatientColumns={false}
                  selectedSource={selectedWeightSource}
                  sourceList={getWeightSourceOptions()}
                  selectedSeverity={selectedWeightSeverity}
                  severityList={getWeightSeverityOptions().slice(1)}
                  selectedBmiStartValue={selectedWeightBmiStartValue}
                  selectedBmiEndValue={selectedWeightBmiEndValue}
                  bmiRange={[ MIN_BMI_VALUE, MAX_BMI_VALUE ]}
                  selectedWeightStartValue={selectedWeightWeightStartValue}
                  selectedWeightEndValue={selectedWeightWeightEndValue}
                  weightRange={[ MIN_WEIGHT_VALUE, MAX_WEIGHT_VALUE ]}
                />
              </div>
            </div>
          )
          : (
            <div
              className={styles.contentWrapper}
              style={{
                height,
              }}
            >
              <EcgLoader />
            </div>
          )
        break
      default:
        break
      }

      return content
    }

    if (!checkRpmFeatureEnabled(me)) {
      return (
        <div
          data-page="patient-file"
          className={styles.patientFile}
        >
          <AccessDeniedContent title="Patient File"/>
        </div>
      )
    }

    return (
      <div
        data-page="patient-file"
        data-value={gaValue}
        className={styles.patientFile}
      >
        {me.isFetching
          ? (
            <EcgLoader />
          )
          : (
            <React.Fragment>
              <ContentHeader
                isLoading={dataIsFetching}
                lastUpdated={dataLastUpdated}
                handleOnRefreshClick={handleOnRefreshClick}
                me={me}
                getText={() => (patients.data && patients.data.byId[selectedPatientId]
            && (
              <div className={styles.headerWrapper}>
                <h1 className={styles.nameText}>
                  {`${patient.firstName} ${patient.lastName}`}
                </h1>
                <p className={styles.mrnTitle}>MRN</p>
                <p className={styles.mrnValue}>
                  {patient.customParticipantID}
                </p>
                {patient.dob &&
                  <p className={styles.yearsOfAge}>
                    <GetAge dob={patient.dob} />
                  </p>
                }
              </div>
            )
                )}
                hasTabs
                showAddPatient={authorizationType !== AUTHORIZATION_TYPES.EPIC && !isIdtfServiceEnabled && this.state.showButtons}
                enableBackButton={authorizationType !== AUTHORIZATION_TYPES.EPIC}
                showCTA
                ctaComponent={!isIdtfServiceEnabled &&
                  <div className={styles.exportReportWrapper}>
                    {this.state.showButtons &&
                    <div
                      className={styles[customReportPopoverOpen ? 'exportReportBtnActive' : 'exportReportBtn']}
                      onClick={toggleCustomReportPopover}
                      data-action="download-report"
                    >
                      {customReportPdf.isFetching ?
                        <div className={styles.exportLoading}>
                          <Loading size="xsmall" />
                        </div>
                        :
                        <DownloadIcon />
                      }
                      <span>Download Report</span>
                    </div>}
                    {customReportPopoverOpen &&
                    <CustomReportDatePopover
                      handleOnOutsidePopoverClick={() => updateCustomReportPopoverState(false)}
                      min={this.beginningDate}
                      max={this.today}
                      dateRange={customReportDateRange}
                      updateCustomReportRequest={updateCustomReportRequest}
                      postReportRequest={fetchCustomReport}
                    />
                    }
                  </div>
                }
              />

              <PageTabs>
                <PageTab
                  isActive={selectedTab === PATIENT_FILE_TABS.OVERVIEW}
                  handleOnClick={() => this.handleOnTabClick(PATIENT_FILE_TABS.OVERVIEW)}
                  // When fetching or loaded with connection status connected or pending show overview
                  label={isIdtfServiceEnabled ? "Profile" : (!patient && dataIsFetching) || (patient && (patient.connectionStatus === 'connected' || patient.connectionStatus === 'pending')) ? 'Overview' : 'Order'}
                />
               {!isIdtfServiceEnabled &&
                <PageTab
                  isActive={selectedTab === PATIENT_FILE_TABS.PROFILE}
                  handleOnClick={() => this.handleOnTabClick(PATIENT_FILE_TABS.PROFILE)}
                  label="Profile"
                />
                }
                {(isIdtfEnabled || isIdtfServiceEnabled) &&
                  <PageTab
                    isActive={selectedTab === PATIENT_FILE_TABS.KARDIA_RX}
                    handleOnClick={() => this.handleOnTabClick(PATIENT_FILE_TABS.KARDIA_RX)}
                    label="KardiaRx ECG"
                  />
                }
                {!isIdtfServiceEnabled &&
                  <PageTab
                    isActive={selectedTab === PATIENT_FILE_TABS.REPORTS}
                    handleOnClick={() => this.handleOnTabClick(PATIENT_FILE_TABS.REPORTS)}
                    label="Reports"
                  />
                }
                {!isIdtfServiceEnabled &&
                  <PageTab
                    isActive={selectedTab === PATIENT_FILE_TABS.EKGS}
                    handleOnClick={() => this.handleOnTabClick(PATIENT_FILE_TABS.EKGS)}
                    label="ECG"
                  />
                }
                {!isIdtfServiceEnabled &&
                  <PageTab
                    isActive={selectedTab === PATIENT_FILE_TABS.BLOOD_PRESSURES}
                    handleOnClick={() => this.handleOnTabClick(PATIENT_FILE_TABS.BLOOD_PRESSURES)}
                    label="Blood Pressure"
                  />
                }
                {!isIdtfServiceEnabled &&
                  <PageTab
                    isActive={selectedTab === PATIENT_FILE_TABS.WEIGHTS}
                    handleOnClick={() => this.handleOnTabClick(PATIENT_FILE_TABS.WEIGHTS)}
                    label="Weight"
                  />
                }
              </PageTabs>

              <section
                data-page={`patient-file-${selectedTab}`}
                className={styles.content}
              >
                {getTabContent(selectedTab)}
              </section>
            </React.Fragment>
          )}
      </div>
    )
  }
}

export default PatientFile



// WEBPACK FOOTER //
// ./src/legacy/pages/PatientFile/PatientFile.jsx